import React, { Component } from "react";
import TopHeader from "../template/TopHeader";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { hairdresserActions, userActions } from "../../_actions";
import { productAction } from "../../_actions/product.action";
import { Plus } from "../SvgIcon";
import "./Clients.css";



function debounce(func, delay) {
    let timer;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(context, args), delay);
    };
  }
class SelectClient extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startTime:this.props.location.state&&this.props.location?.state?.pageLoadingStatus===0&&this.props.location.state.start&&this.props.location.state.start!==""?this.props.location.state.start:"",
            hairdresserClient:[],
          isLoading:true,
          searchQuery:this.props.location.state&&this.props.location.state.searchQuery?this.props.location.state.searchQuery:"",
          tempClientRecord:[],
          currentLoadingStatus:0,
          previousPage:this.props.location.state&&this.props.location?.state?.pageLoadingStatus===0&&this.props.location.state.previousPageUrl&&this.props.location.state.previousPageUrl!==""?this.props.location.state.previousPageUrl:"",
          currentPage: 1,
          hasMore: true,
          isLoadingMore: false,
          pagination: null
        }
        this.debouncedSearch = debounce(this.debouncedFunction, 500);
        this.searchClient = this.searchClient.bind(this);
        this.debouncedFunction = this.debouncedFunction.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.loadMoreClients = this.loadMoreClients.bind(this);
    }

    debouncedFunction() {
        let self = this;
        const hairdresserId = localStorage.getItem("userId");
        
        // Reset to page 1 when searching
        // Use server-side search with new paginated API
        let params = {
          searchKey: this.state.searchQuery,
          hairdresserId: hairdresserId,
          page: 1,
          limit: 50,
          listType: 1,
          isDownload: 0,
        };
        
        self.setState({
          currentPage: 1,
          hairdresserClient: [],
          hasMore: true,
          isLoading: true
        }, () => {
          self.getHairdresserClient(params);
        });
    }

    handleScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollHeight = document.documentElement.scrollHeight;
        const clientHeight = document.documentElement.clientHeight;
        
        // Load more when user scrolls to bottom (with 100px threshold)
        if (scrollTop + clientHeight >= scrollHeight - 100) {
            this.loadMoreClients();
        }
    }

    loadMoreClients() {
        const { isLoadingMore, hasMore, currentPage, searchQuery } = this.state;
        
        // Don't load if already loading or no more data
        if (isLoadingMore || !hasMore) {
            return;
        }
        
        const hairdresserId = localStorage.getItem("userId");
        const nextPage = currentPage + 1;
        
        this.setState({ isLoadingMore: true });
        
        let params = {
          searchKey: searchQuery,
          hairdresserId: hairdresserId,
          page: nextPage,
          limit: 50,
          listType: 1,
          isDownload: 0,
        };
        
        this.props.dispatch(hairdresserActions.getHairdresserClient(params))
            .then(() => {
                this.setState({
                    currentPage: nextPage,
                    isLoadingMore: false
                });
            })
            .catch(() => {
                this.setState({ isLoadingMore: false });
            });
    }

    searchClient(e) {
        let self = this;
        self.setState({
            searchQuery: e.target.value,
        }, function () {
            this.debouncedSearch();
        });
    }

    componentDidMount() {
      let self = this;
      const {hairdresserClient } = this.props;
      const { state } = self?.props?.location;
      if (state) {
        console.log("state",state);
        const { pageLoadingStatus , previousPageUrl, start} = state;
        if(pageLoadingStatus===0){
          self.setState({
            currentLoadingStatus:pageLoadingStatus,
            previousPage:previousPageUrl,
            startTime:start,
          })
        }
      }
      if (localStorage.getItem("accessToken")) {
        const hairdresserId = localStorage.getItem("userId");

        let params = {
          searchKey: '',
          hairdresserId: hairdresserId,
          page: 1,
          limit: 50,
          listType: 1,
          isDownload: 0,
        };
      
        this.getHairdresserClient(params);
        
        // Add scroll event listener for infinite scroll
        window.addEventListener('scroll', this.handleScroll);
      } else {
        this.props.history.push("/");
      }
    }

    componentWillUnmount() {
      // Clean up scroll event listener
      window.removeEventListener('scroll', this.handleScroll);
    }


    getHairdresserClient(params) {
      var self = this;
      return self.props.dispatch(hairdresserActions.getHairdresserClient(params))
    }
  
    componentDidUpdate(prevProps, prevState) {
      const _hairdresser = this.props.hairdresserClient;
      if (_hairdresser !== prevProps.hairdresserClient) {
        if(_hairdresser.client !== undefined){
          const sortedClient = _hairdresser?.client?.sort((a, b) => a.name - b.name);
          const newPagination = _hairdresser?.pagination;
          
          // Check if we're loading more (page > 1) or starting fresh (page 1)
          const isLoadingMore = this.state.currentPage > 1;
          
          this.setState({
            hairdresserClient: isLoadingMore
              ? [...this.state.hairdresserClient, ...sortedClient]  // Append new clients
              : sortedClient,  // Replace clients (new search or initial load)
            tempClientRecord: sortedClient,
            isLoading: false,
            pagination: newPagination,
            hasMore: newPagination?.hasMore || false
          });
        } else {
          this.setState({
            hairdresserClient: [],
            tempClientRecord: [],
            isLoading: false,
            hasMore: false
          });
        }
      }
    }

    // Removed localDataFilter and _searchWord methods - now using server-side search

     handleClick(selectedClient){
      const { dispatch,history } = this.props;
      const indexId = +this?.props?.match?.params?.indexId;
      selectedClient.indexId = indexId;
      let currentPageUrl = history.location.pathname;
      
      console.log('handleClick - indexId:', indexId);
      
      // Store the original item type in the client object to preserve it
      // This will be used when returning to the checkout page
      selectedClient.preserveItemType = true;
      
      dispatch(productAction.selectedClient(selectedClient));
      
      // Include a flag to indicate that we're returning from client selection
      // and include the indexId to ensure we can identify the correct item
      const stateObj = {
        pageLoadingStatus: this.state.currentLoadingStatus,
        previousPageUrl: currentPageUrl,
        start: this.state.startTime,
        fromClientSelection: true,
        indexId: indexId
      };
      
      const url = this.state.previousPage;
      history.push({
        pathname: url,
        state: stateObj,
      });
     }

     handleShowAddClientModal = () =>  {
        let self=this;
        // propes.history.push('/clients')
         let { state } = self?.props?.location;
         if (state) {
             let {pageLoadingStatus, previousPageUrl, start} = state;
             let stateObj=self.props?.location?.state;
             // self.props.history.push('/clients/booking/add',{pageLoadingStatus, previousPageUrl, start});
             self.props.history.push({
                 pathname: '/clients/booking/add',
                 state: stateObj,
             });
         }else{
             self.props.history.push('/clients/booking/add',);
         }
    }

    checkEmail = (email) => {
        let emailArr = email.split("@");
        if (emailArr[1] === "beuapp.com") {
            return false;
        } else {
            return true;
        }
    };

  render() {
        console.log("this.state",this.state);
      console.log("this.props",this.props);
    return (
        <div className="h_n">
          <div className="body_container cm_bg_white">
            <TopHeader 
            headerButtonStatus={true}
            cancelButton={true}
            saveBookingButton={false}
            checkoutButton={false}
            title="Clients" 
               {...this.props}
            previousPageUrl={this.state.previousPage}
            />
            <div className="container">
              <div className="checkout-client">
                <div className="cm_search_wrapper client_search  mt-3 mb-3" style={{ position: 'relative' }}>
                <input
                    type="text"
                    className="form-control"
                    value={this.state.searchQuery}
                    placeholder="Search by name, email, number"
                    name="searchKey"
                    onChange={this.searchClient}
                    style={{ paddingRight: '40px' }}
                />
                <i className="fa fa-search" style={{ position: 'absolute', right: '15px', top: '50%', transform: 'translateY(-50%)' }} />
                </div>
                <button
                  className="btn mb-3"
                  onClick={()=>this.handleShowAddClientModal()}
                  style={{
                    width: '100%',
                    padding: '16px',
                    background: '#1a1a1a',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '16px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px'
                  }}
                >
                  <span style={{ display: 'flex', alignItems: 'center' }}><Plus /></span>
                  Add New Client
                </button>
                <div className="table-responsive client_table mt-0">
                        <table className="table">
                            <tbody>
                              {this.state.isLoading ? (
                                // Skeleton loader rows
                                [...Array(15)].map((_, i) => (
                                  <tr key={`skeleton-${i}`} className="skeleton-row">
                                    <td className="alfa_text"></td>
                                    <td>
                                      <div className="d-flex align-items-center">
                                        <div className="skeleton-avatar" style={{ width: '40px', height: '40px' }}></div>
                                        <div className="ml-3" style={{ flex: 1 }}>
                                          <div className="skeleton-text skeleton-name" style={{ width: '60%', height: '16px', marginBottom: '8px' }}></div>
                                          <div className="skeleton-text skeleton-email" style={{ width: '80%', height: '12px' }}></div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : this.state.hairdresserClient?.length > 0 ? (
                                this.state.hairdresserClient.map((client, i) => (
                                  <tr key={i + '_client'} className="pointer-event" onClick={() => this?.handleClick(client)}>
                                    <td className="alfa_text">
                                      <h3 className="cm_fw_b">{(this.state.hairdresserClient[i - 1] && this.state.hairdresserClient[i]?.nameLower?.[0] !== this.state.hairdresserClient[i - 1]?.nameLower?.[0]) || i == 0 ? client?.nameLower?.[0]?.toUpperCase() : ""}</h3>
                                    </td>
                                    <td>
                                      <p style={{ fontFamily: 'inherit', margin: 0 }}>{client?.name}</p>
                                      <p style={{ fontFamily: 'inherit', margin: 0, color: 'inherit' }}>{this.checkEmail(client.email) ? client.email : "--"}</p>
                                      {client?.phoneNumber && <p style={{ fontFamily: 'inherit', margin: 0, fontSize: 'inherit', color: 'inherit' }}>{client.phoneNumber}</p>}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={2}>
                                    <p className="text-center">Client not found.</p>
                                  </td>
                                </tr>
                              )}
                              {this.state.isLoadingMore && (
                                // Skeleton loader rows for loading more
                                [...Array(15)].map((_, i) => (
                                  <tr key={`skeleton-more-${i}`} className="skeleton-row">
                                    <td className="alfa_text"></td>
                                    <td>
                                      <div className="d-flex align-items-center">
                                        <div className="skeleton-avatar" style={{ width: '40px', height: '40px' }}></div>
                                        <div className="ml-3" style={{ flex: 1 }}>
                                          <div className="skeleton-text skeleton-name" style={{ width: '60%', height: '16px', marginBottom: '8px' }}></div>
                                          <div className="skeleton-text skeleton-email" style={{ width: '80%', height: '12px' }}></div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                        </table>
                </div>
              </div>
  
             
            </div>
          </div>
        </div>
      );
  }
}
function mapStateToProps(state) {
    return {
      ...state,
    };
  }
  
  export default connect(mapStateToProps)(SelectClient);